export const getAuthUser = () => {
  const user = {};
  const prefix = "techtop_user_";

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (key?.startsWith(prefix)) {
      const newKey = key.substring(prefix.length);
      user[newKey] = localStorage.getItem(key);
    }
  }

  if (!user.name) {
    user.name = [user.first_name, user.last_name].filter(Boolean).join(' ');
  }

  return user;
};
